import React from "react";
import { Target, Heart, Recycle } from "lucide-react";

const APPROACH_ILLUSTRATION =
    "https://customer-assets.emergentagent.com/job_afad2a6d-7dba-488f-b2fd-a41c3f20dfe4/artifacts/332un0yy_Brandstyle%20%20Illustraties%206.jpg";

const PILLARS = [
    {
        id: "value-enablement",
        icon: Target,
        title: "Value Enablement",
        text: "We define what value means in your context — financial, operational, social — and instrument the business to measure it from day one.",
    },
    {
        id: "customer-experience",
        icon: Heart,
        title: "Customer Experience",
        text: "We design lifecycle experiences that deepen trust and retention, blending COPC® rigour with the empathy your brand stands for.",
    },
    {
        id: "sustainable-lifecycle",
        icon: Recycle,
        title: "Sustainable Lifecycle",
        text: "Outcomes that endure — purpose-aligned operating models, inclusive practices and Vested® commercial frameworks for long-term growth.",
    },
];

export default function Approach() {
    return (
        <section
            id="approach"
            data-testid="approach-section"
            className="relative py-24 md:py-32 bg-gray-50 border-y border-gray-200"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="grid lg:grid-cols-12 gap-12 items-start">
                    <div className="lg:col-span-5">
                        <span
                            data-testid="approach-eyebrow"
                            className="eyebrow text-bpo-cyanDark"
                        >
                            Our approach
                        </span>
                        <h2 className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-bpo-ink leading-[1.05]">
                            Three pillars,
                            <span className="block text-bpo-cyan">
                                one outlook.
                            </span>
                        </h2>
                        <p className="mt-6 text-base md:text-lg text-bpo-charcoal/80 leading-relaxed">
                            Every BPO Solutions engagement is shaped around
                            three reinforcing pillars — designed to convert
                            certification rigour into outcomes your team can
                            feel.
                        </p>

                        <div className="mt-8 rounded-3xl border border-gray-200 bg-white p-2 shadow-[0_20px_50px_-30px_rgba(45,212,212,0.45)]">
                            <img
                                src={APPROACH_ILLUSTRATION}
                                alt="Value enablement, customer experience and sustainable lifecycle"
                                className="w-full h-auto rounded-2xl object-cover"
                            />
                        </div>
                    </div>

                    <div className="lg:col-span-7 lg:pl-6">
                        <ol className="relative space-y-6">
                            {PILLARS.map((p, idx) => {
                                const Icon = p.icon;
                                return (
                                    <li
                                        key={p.id}
                                        data-testid={`approach-pillar-${p.id}`}
                                        className="group relative rounded-2xl bg-white border border-gray-200 p-7 md:p-9 hover:shadow-[0_20px_40px_-20px_rgba(31,41,55,0.2)] transition-all"
                                    >
                                        <div className="flex flex-col md:flex-row md:items-start gap-6">
                                            <div className="flex items-center gap-4 md:flex-col md:items-start md:gap-3 md:w-32 shrink-0">
                                                <span className="font-display text-3xl md:text-4xl font-extrabold text-bpo-cyan leading-none">
                                                    0{idx + 1}
                                                </span>
                                                <div className="h-12 w-12 rounded-xl bg-bpo-ink text-white flex items-center justify-center">
                                                    <Icon className="h-6 w-6" />
                                                </div>
                                            </div>
                                            <div className="flex-1">
                                                <h3 className="font-display text-2xl md:text-3xl font-extrabold tracking-tight text-bpo-ink leading-tight">
                                                    {p.title}
                                                </h3>
                                                <p className="mt-3 text-[15px] md:text-base text-bpo-charcoal/80 leading-relaxed">
                                                    {p.text}
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                );
                            })}
                        </ol>
                    </div>
                </div>
            </div>
        </section>
    );
}
